var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-progress-linear',{class:_vm.progressClass,attrs:{"indeterminate":true,"color":"accent"}})}
var staticRenderFns = []

export { render, staticRenderFns }